<template>
	<div class="creative dalle-creative">
		<div class="info">
			<div class="prompt">{{ creative.prompt }}</div>
			<div class="style">{{ creative.style }}</div>
		</div>

		<div class="results">
			<div v-if="isGenerating" class="loader">
				<i class="fa fa-spinner fa-spin fa-fw" />
				<div class="percentage">{{ creative.percentage }}%</div>
			</div>

			<div class="images">
				<div v-for="(result, index) in displayResults" :key="`result-${index}`" class="creative">
					<div>
						<img v-if="result && result.path" :src="result.path" :alt="creative.prompt" />
						<div v-else class="loading-box">
							<div class="loading-overlay">
								<i class="fa fa-spinner fa-spin fa-fw" />
							</div>
						</div>
						<div class="actions" v-if="result && result.path">
							<div @click="onAdd(result.path)" class="action">
								<i class="fa fa-plus fa-fw" />
							</div>
							<div @click="onDownload(result.path)" class="action">
								<i class="fa fa-download fa-fw" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'dalle-creative',
	props: {
		creative: {
			type: Object,
			required: true,
			default: () => ({})
		}
	},

	data() {
		return {
			imageResults: Array(4).fill({}),
			savedResults: null
		}
	},

	computed: {
		isGenerating() {
			return this.creative.percentage < 100 && this.creative.status !== 'completed'
		},
		hasImages() {
			return this.imageResults.some(img => img && img.path)
		},
		displayResults() {
			// Always use savedResults once we have them
			return this.savedResults || this.imageResults
		}
	},

	watch: {
		'creative.dalleImageResults': {
			immediate: true,
			handler(newVal) {
				if (Array.isArray(newVal)) {
					this.imageResults = Array(4).fill({}).map((_, index) => {
						return newVal[index] || {}
					})

					if (newVal.some(img => img && img.path)) {
						// Preserve existing saved images and add new ones
						const currentSaved = this.savedResults || Array(4).fill({})
						this.savedResults = currentSaved.map((saved, index) => {
							const newImage = newVal[index]
							// Keep existing saved image or use new one if it has a path
							return (saved && saved.path) ? saved : (newImage || {})
						})
					}
				}
			}
		}
	},

	methods: {
		onAdd(path) {
			this.$emit('add', path)
		},

		onRemove() {
			this.$emit('remove')
		},

		onDownload(path) {
			const link = document.createElement('a')
			link.download = 'image.png'
			link.href = path
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		}
	}
}
</script>

<style lang="scss" scoped>
.dalle-creative {
	margin-bottom: 30px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 15px 0;
	border-top: 1px solid #eee;

	&:first-child {
		border-top: 0;
	}

	.info {
		display: flex;
		flex-direction: column;
		gap: 10px;
		flex: 1;

		.prompt {
			color: #333;
			font-size: 14px;
			font-style: italic;
			border-radius: 8px;
			padding: 6px 10px;
			border: 2px solid #eee;
		}

		.style {
			display: inline-block;
			font-size: 12px;
			font-weight: 500;
			color: #666;
			margin-bottom: 5px;
			padding: 4px 6px;
			border-radius: 4px;
			background-color: #eee;
		}
	}

	.results {
		.images {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			gap: 16px;
			margin-top: 16px;

			.creative {
				position: relative;
				aspect-ratio: 1;
				border-radius: 8px;
				overflow: hidden;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}

				.actions {
					position: absolute;
					top: 8px;
					right: 8px;
					display: flex;
					gap: 8px;
					opacity: 0;
					transition: opacity 0.2s;

					.action {
						width: 32px;
						height: 32px;
						display: flex;
						align-items: center;
						justify-content: center;
						background: rgba(255, 255, 255, 0.9);
						border-radius: 4px;
						cursor: pointer;

						&:hover {
							background: white;
						}

						i {
							color: #333;
						}
					}
				}

				&:hover .actions {
					opacity: 1;
				}
			}

			.loading-box {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				gap: 8px;
				background: rgba(255, 255, 255, 0.9);

				.loading-overlay {
					text-align: center;

					i {
						font-size: 24px;
						color: #666;
						margin-bottom: 8px;
					}

					.percentage {
						font-size: 14px;
						font-weight: 500;
						color: #666;
					}
				}
			}
		}
	}
}
</style>
